/**
 * Autocomplete
 */

import { memo } from 'react';

import { Autocomplete as MuiAutocomplete } from '@mui/material';

import { FormField } from 'app/components';

import { AutocompleteSelectType } from 'app/components/AutocompleteSelect/types';
import { SelectOptionType } from 'app/components/Select/types';

export const AutocompleteSelect = ({
  options,
  placeholder,
  searchFieldName,
  onChange,
  noOptionsText,
  name,
  defaultValue,
}: AutocompleteSelectType) => (
  <MuiAutocomplete
    className="autoComplete"
    aria-label={name}
    options={options}
    sx={{ width: 300 }}
    noOptionsText={noOptionsText}
    defaultValue={defaultValue}
    onChange={(e, value: SelectOptionType | null) => onChange(value?._id ?? '')}
    renderInput={params => (
      // No aria-label here: FormField.Input already labels the <input> itself
      // from `name`. In MUI 5 that inner label was lost (Autocomplete's params
      // overrode it) so this top-level one was the only label, landing on the
      // wrapper div. v9 keeps both, which is two elements with the same label -
      // and the control, not the wrapper, is the one that should carry it.
      <FormField.Input
        {...params}
        name={searchFieldName}
        placeholder={placeholder}
      />
    )}
  />
);

export default memo(AutocompleteSelect);
